import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '../../shared/state/store';
import {getv2Reports} from '../state/users/admin-thunk';
import QuickSightEmbed from './quicksight-embed';
import {configSettings} from '../../shared/configuration/config-settings';

interface QuickSightDashboardProps {
  reportId: number;
  clientId: number;
  startDate: string;
  endDate: string;
}

function QuickSightDashboard(props: QuickSightDashboardProps) {
  const dispatch = useDispatch<AppDispatch>();
  const {reportId, clientId, startDate, endDate} = props;
  const [dashboardUrl, setDashboardUrl] = useState<string | null>(null);
  const [isLoadingDash, setIsLoadingDash] = useState<boolean>(false);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current && reportId !== null && clientId !== null) {
      hasFetched.current = true;
      fetchDashboardEmbed();
    }
  }, [clientId, reportId, startDate, endDate]);

  const fetchDashboardEmbed = async () => {
    setIsLoadingDash(true);

    try {
      const response = await dispatch(getv2Reports(reportId));
      const embedUrl = new URL(response.payload.embedUrl);
      const appEnv = configSettings.app_environment;
      const baseURL = `https://report.${appEnv}.finpay.net/`;

      embedUrl.searchParams.set('clientId', clientId.toString());
      embedUrl.searchParams.set('startDate', startDate);
      embedUrl.searchParams.set('endDate', endDate);
      embedUrl.searchParams.set('baseURL', baseURL);

      setDashboardUrl(embedUrl.toString());
      hasFetched.current = false;
    } catch (error) {
      console.error('Error fetching dashboard URL:', error);
    } finally {
      setIsLoadingDash(false);
    }
  };

  return (
    <QuickSightEmbed
      dashboardUrl={dashboardUrl}
      isLoading={isLoadingDash}
    />
  );
}

export default QuickSightDashboard;
